/**
 * Montserrat Text Component
 * Styled text with Montserrat font
 * @param {string} variant - Text variant (h1, h2, h3, h4, body, caption)
 * @param {string} weight - Font weight (light, normal, semibold, bold, extrabold)
 * @param {string} color - Text color class
 * @param {ReactNode} children - Content
 */
export default function MontserratText({
  variant = 'body',
  weight = 'normal',
  color = 'text-gray-900',
  className = '',
  children,
  ...props
}) {
  const variantMap = {
    h1: 'text-5xl md:text-6xl leading-tight',
    h2: 'text-5xl md:text-6xl leading-tight',
    h3: 'text-3xl md:text-4xl leading-tight',
    h4: 'text-2xl md:text-3xl leading-snug',
    body: 'text-base md:text-lg leading-relaxed',
    caption: 'text-sm md:text-base leading-relaxed',
  };

  const weightMap = {
    light: 'font-light',
    normal: 'font-normal',
    semibold: 'font-semibold',
    bold: 'font-bold',
    extrabold: 'font-extrabold',
  };

  const Component = variant.startsWith('h') ? variant : 'p';

  return (
    <Component
      className={`font-montserrat ${variantMap[variant] || variantMap.body} ${
        weightMap[weight] || weightMap.normal
      } ${color} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
}
